import { ProjectType } from '@lopo-tech/lopo-api'
import React from 'react'
import { ProjectMeetingsPage } from 'src/pages/project_meetings'

const InfrastructureProjectMeetingsPage: React.FC = () => (
  <ProjectMeetingsPage projectType={ProjectType.InfrastructureProject} />
)

export default InfrastructureProjectMeetingsPage
